import { Button, Group } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

import { styles } from '../../styles';
import { useProposal } from '../../context/ProposalContext';
import SaveProposal from '../Buttons/SaveProposal';
import DeleteProposal from '../Buttons/DeleteProposal';
import GenerateWordDoc from '../Buttons/GenerateWordDoc';

export default function ActionButtons() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  // Handle Discard
  const handleDiscard = () => {
    const newPath = location.pathname.split('/').slice(0, -1).join('/');
    navigate(newPath);
  };

  return (
    <Group justify="flex-end" align="center" mt="md">
      <SaveProposal />
      <GenerateWordDoc />
      {/* <Button
        color="gray"
        variant="light"
        leftSection={<IconX size={18} />}
        onClick={handleDiscard}
      >
        {t('cancelChanges')}
      </Button> */}
      <DeleteProposal />
    </Group>
  );
}
